import { alpha, PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { grey } from './colors';
import { buildPaletteFromMetadata, type Token } from './panw-palette/token-metadata';

const actionTokens = [
  { propertyPath: 'disabled', tokenName: '--semantic-text-disabled' },
  { propertyPath: 'disabledBackground', tokenName: '--semantic-bg-interactive-neutral-disabled' },
  { propertyPath: 'hover', tokenName: '--semantic-bg-interactive-neutral-hover' },
  { propertyPath: 'selected', tokenName: '--semantic-bg-interactive-neutral-active' },
] satisfies Token[];

export const action = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['action'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(actionTokens, tokens, xcorTokens);
  }

  const hover = alpha(grey[300], 0.2);
  const selected = alpha(grey[300], 0.35);

  return mode === 'light'
    ? {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.5),
        disabled: alpha(grey[500], 0.6),
      }
    : {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.35),
        disabled: alpha(grey[300], 0.5),
      };
};
